<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  @if (isScaleMode) {
    <div
      role="radiogroup"
      class="horizontal-scale"
      [style.--scale-columns]="scaleColumns"
    >
      @for (alternative of question.alternatives; track $index) {
        <app-single-select-radio-button
          [question]="question"
          [alternative]="alternative"
          [control]="control"
          [otherControl]="otherControl"
          [quotaErrorAlternativeId]="quotaErrorAlternativeId"
        ></app-single-select-radio-button>
      }
    </div>
  } @else if (
    question.presentation === "VERTICAL" ||
    question.presentation === "HORIZONTAL"
  ) {
    <div
      role="radiogroup"
      [ngClass]="{
        '': question.presentation === 'VERTICAL',
        'horizontal-grid': question.presentation === 'HORIZONTAL',
      }"
      [style.--item-min-width.px]="
        question.presentation === 'HORIZONTAL' ? getMinTileWidth() : null
      "
    >
      @for (alternative of question.alternatives; track $index) {
        <app-single-select-radio-button
          [question]="question"
          [alternative]="alternative"
          [control]="control"
          [otherControl]="otherControl"
          [quotaErrorAlternativeId]="quotaErrorAlternativeId"
        ></app-single-select-radio-button>
      }
    </div>
  } @else if (question.presentation === "SLIDER") {
    <app-slider [question]="question" [control]="control"></app-slider>
  }
  @if (control?.hasError("required") && control.touched) {
    <app-validator
      [question]="question"
      [validator]="ValidatorType.RequiredSelect"
    />
  }
  @if (control?.hasError("QuotaError") && control.touched) {
    <app-validator
      [question]="question"
      [validator]="ValidatorType.QuotaError"
      [control]="control"
    />
  }
</app-question-base>
